import { useState } from "react"
import type { StoryblokRichtext } from "storyblok-rich-text-react-renderer"

import type { Nullish } from "~/@types/generics"
import { truncate } from "~/components/ui/RichText/utils/truncate"

export default function useTruncateRichText(richtext: Nullish<StoryblokRichtext>, maxChars: number) {
  const [isReadMore, setIsReadMore] = useState(true)
  const text = isReadMore ? truncate(richtext, maxChars) : richtext

  return { setIsReadMore, isReadMore, text }
}
